import React from "react";
import RecordNoImage from "../../../../components/recordNotFound/RecordNoImage";
import ClientsJobCard from "../ClientsJobCard";

function JobListing({
  data,
  setJobListing,
  fetchDetails,
  handleMoveJobCandidates,
  handleMoveJobDetails,
  setCardToOpen,
}) {
  return (
    <div className="right-side-job-listing clients-sidebar p-2">
      <div
        className="pb-3 border-bottom d-flex flex-wrap align-items-center justify-content-between  p-2 margin-lef-right "
        style={{
          width: "100%",
          marginRight: "2px",
          overflow: "hidden",
          marginLeft: "0px !important",
        }}
      >
        <span className="profile-section-heading mb-0">Jobs</span>

        <button
          className="outlined-btn h-auto"
          onClick={() => {
            setCardToOpen("job");
          }}
        >
          View All
        </button>
      </div>

      <div
        className="no-scrollbar"
        style={{
          width: "100%",
          padding: "12px",
          overflowY: "auto",
          WebkitOverflowScrolling: "touch",
          // zoom effect change
          //   height: "calc(107vh - 185px)",
        }}
      >
        {data.jobs?.length > 0 ? (
          data.jobs.map((job) => (
            <ClientsJobCard
              job={job}
              setListing={setJobListing}
              fetchDetails={fetchDetails}
              handleMoveJobCandidates={handleMoveJobCandidates}
              handleMoveJobDetails={handleMoveJobDetails}
            />
          ))
        ) : (
          <div className="mt-5">
            <RecordNoImage title="No Jobs Found" />
          </div>
        )}
      </div>
    </div>
  );
}

export default JobListing;
